import * as FileSaver from 'file-saver'
import moment from 'moment'
import * as XLSX from 'xlsx-js-style'
import { styleTableSheet } from 'utils/excelStyle'

export const handleDownloadExcel = (
  fileNameSheet,
  dataItems,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  grandTotal,
) => {
  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(() => {
    setIsDownload(true)
    setFirstRows(0)
    setTotalRows(dataItems.length)

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const bookType = 'xlsx'
    let count = 2

    const totalItems = dataItems.length
    const chunkSize = Math.max(Math.floor(totalItems * 0.1), 100)

    const exportHeader = [
      'Jenis',
      'Barang',
      'Volume',
      'Satuan',
      'PSDH',
      'Kewajiban Bayar',
    ]
    const ws = XLSX.utils.book_new()
    XLSX.utils.sheet_add_aoa(ws, [exportHeader])

    const processChunk = (start) => {
      if (start >= totalItems) {
        setFirstRows(totalItems)

        const grandTotalRow = ['', '', '', '', 'Total Bayar', grandTotal]

        XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 })

        setTimeout(() => {
          styleTableSheet(ws)
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
          const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
          const finalData = new Blob([excelBuffer], { type: fileType })

          FileSaver.saveAs(
            finalData,
            `${fileNameSheet}_${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
          )

          setTimeout(() => {
            setIsDownload(false)
          }, 2000)
        }, 500)

        return
      }

      const chunk = dataItems
        ?.slice(start, start + chunkSize)
        ?.map((row) => [
          row?.type?.value,
          row?.commodity?.value,
          row?.volume,
          row?.unit?.value,
          row?.psdh,
          row?.total,
        ])

      XLSX.utils.sheet_add_json(ws, chunk, {
        origin: `A${count}`,
        skipHeader: true,
      })
      count += chunk.length

      setFirstRows(start + chunk.length)

      setTimeout(() => processChunk(start + chunkSize), 300)
    }

    processChunk(0)
  }, 300)
}

export const handleSummaryDownloadExcel = (
  fileNameSheet,
  groupedData,
  setIsDownload,
  setFirstRows,
  setTotalRows,
  grandTotal,
) => {
  setIsDownload(false)
  setFirstRows(0)
  setTotalRows(0)

  setTimeout(() => {
    setIsDownload(true)
    setFirstRows(0)
    setTotalRows(groupedData.length)

    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const bookType = 'xlsx'
    let count = 2

    const totalItems = groupedData.length
    const chunkSize = Math.max(Math.floor(totalItems * 0.1), 100)

    const exportHeader = [
      'Jenis',
      'Volume',
      'Satuan',
      'PSDH',
      'Kewajiban Bayar',
    ]
    const ws = XLSX.utils.book_new()
    XLSX.utils.sheet_add_aoa(ws, [exportHeader])

    const processChunk = (start) => {
      if (start >= totalItems) {
        setFirstRows(totalItems)

        const grandTotalRow = ['', '', '', 'Total Bayar', grandTotal]

        XLSX.utils.sheet_add_aoa(ws, [grandTotalRow], { origin: -1 })

        setTimeout(() => {
          styleTableSheet(ws)
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
          const excelBuffer = XLSX.write(wb, { bookType, type: 'array' })
          const finalData = new Blob([excelBuffer], { type: fileType })

          FileSaver.saveAs(
            finalData,
            `${fileNameSheet}_${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
          )

          setTimeout(() => {
            setIsDownload(false)
          }, 2000)
        }, 500)

        return
      }

      const chunk = groupedData
        ?.slice(start, start + chunkSize)
        ?.map((row) => [
          row?.type?.value,
          row?.volume,
          row?.unit?.value,
          row?.psdh,
          row?.total,
        ])

      XLSX.utils.sheet_add_json(ws, chunk, {
        origin: `A${count}`,
        skipHeader: true,
      })
      count += chunk.length

      setFirstRows(start + chunk.length)

      setTimeout(() => processChunk(start + chunkSize), 300)
    }

    processChunk(0)
  }, 300)
}

// FUNCTION CONVERT TO ROMAN
const convertToRoman = (num) => {
  const romanNumerals = [
    '',
    'I',
    'II',
    'III',
    'IV',
    'V',
    'VI',
    'VII',
    'VIII',
    'IX',
    'X',
    'XI',
    'XII',
  ]
  return romanNumerals[num] || ''
}

export const generatePNBPExcel = (data, capacityTruck) => {
  const capacity = Number(capacityTruck) || 10

  // HELPER FUNCTION TO FORMAT NUMBER
  const formatNumber = (num) => {
    if (Number.isInteger(num)) {
      return num.toString()
    }
    return num.toFixed(2)
  }

  // GROUPING DATA - GROUP BY TYPE
  const grouped = {}
  data.forEach((item) => {
    const key = item.type.label.toLowerCase() // ONLY GROUP BY TYPE, IGNORE UNIT
    if (!grouped[key]) {
      grouped[key] = {
        jenis: item.type.label,
        volume: 0,
      }
    }
    // CONVERT ALL TO KG FIRST FOR CONSISTENT CALCULATION
    let volumeKg = Number(item.volume) || 0
    if (item.unit.label.toLowerCase() === 'ton') {
      volumeKg = volumeKg * 1000
    }
    grouped[key].volume += volumeKg
  })

  // CREATE WORKSHEET BU DAN LHP
  const buLhpRows = [
    ['No', 'JENIS', 'VOLUME', 'BUKU UKUR', '', 'LAPORAN PRODUKSI', ''],
    ['', '', '', 'NOMOR', 'TANGGAL', 'NOMOR', 'TANGGAL'],
  ]

  let index = 1
  for (const key in grouped) {
    const entry = grouped[key]
    buLhpRows.push([
      index++,
      entry.jenis,
      `${formatNumber(entry.volume / 1000)} Ton`, // CONVERT BACK TO TON FOR DISPLAY
      '',
      '',
      '',
      '',
    ])
  }

  const buLhpWorksheet = XLSX.utils.aoa_to_sheet(buLhpRows)
  buLhpWorksheet['!merges'] = [
    { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },
    { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },
  ]

  // CREATE WORKSHEET SKSHHBK
  const sksRows = [
    ['No', 'JENIS', 'VOLUME', 'SKS-HHBK', ''],
    ['', '', '', 'Nomor', 'Tanggal'],
  ]

  const merges = [{ s: { r: 0, c: 3 }, e: { r: 0, c: 4 } }]

  // GET CURRENT DATE COMPONENTS
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth() + 1
  const currentYear = currentDate.getFullYear()
  const romanMonth = convertToRoman(currentMonth)
  const formattedDate = moment().format('DD/MM/YYYY')

  let groupIndex = 1
  let rowIndex = 2 // START FROM ROW INDEX 2 (AFTER HEADER)
  let sksCounter = 1 // COUNTER START FROM 1

  for (const key in grouped) {
    const entry = grouped[key]
    const volumeTon = entry.volume / 1000 // CONVERT KG TO TON

    const fullUnits = Math.floor(volumeTon / capacity)
    const remainder = volumeTon % capacity
    const totalRows = fullUnits + (remainder > 0 ? 1 : 0)

    const groupStartRow = rowIndex

    // GENERATE ROWS FOR THIS GROUP
    for (let i = 0; i < totalRows; i++) {
      let rowVolume
      if (i < fullUnits) {
        rowVolume = capacity // FULL CAPACITY FOR ALL FULL UNITS
      } else {
        rowVolume = remainder // REMAINDER FOR THE LAST ROW
      }

      // GENERATE UNIQUE SKS NUMBER FOR EACH ROW
      const nomorUrut = String(sksCounter).padStart(3, '0')
      const nomorSks = `${nomorUrut}/SKS-HHBK/KTH.GRM/${romanMonth}/${currentYear}`

      if (i === 0) {
        // FIRST ROW IN GROUP - SHOW GROUP NUMBER AND TYPE
        sksRows.push([
          groupIndex,
          entry.jenis,
          `${formatNumber(rowVolume)} Ton`,
          nomorSks,
          formattedDate,
        ])
      } else {
        // SUBSEQUENT ROWS IN GROUP - ONLY SHOW VOLUME AND SKS NUMBER
        sksRows.push([
          '',
          '',
          `${formatNumber(rowVolume)} Ton`,
          nomorSks,
          formattedDate,
        ])
      }

      sksCounter++
      rowIndex++
    }

    // MERGE GROUP CELLS IF MULTIPLE ROWS
    const groupEndRow = rowIndex - 1
    if (groupEndRow > groupStartRow) {
      merges.push(
        { s: { r: groupStartRow, c: 0 }, e: { r: groupEndRow, c: 0 } },
        { s: { r: groupStartRow, c: 1 }, e: { r: groupEndRow, c: 1 } },
      )
    }

    groupIndex++
  }

  const sksWorksheet = XLSX.utils.aoa_to_sheet(sksRows)
  sksWorksheet['!merges'] = merges

  // CREATE WORKBOOK
  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(
    workbook,
    styleTableSheet(buLhpWorksheet, { headerRows: 2 }),
    'BU DAN LHP',
  )
  XLSX.utils.book_append_sheet(
    workbook,
    styleTableSheet(sksWorksheet, { headerRows: 2 }),
    'SKSHHBK',
  )

  // EXPORT FILE
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const fileBlob = new Blob([excelBuffer], { type: 'application/octet-stream' })
  FileSaver.saveAs(
    fileBlob,
    `DOKUMEN_BU_LHP_SKSHHBK_${moment().format('YYYY-MM-DD HH:mm:ss')}.xlsx`,
  )
}
